import React, { lazy } from 'react'
import { Route } from 'react-router'
import { SubRouter } from '@/router/SubRouter'

const Index = lazy(() => import('./Index'))

export const StockRouter = React.memo(() => (
  <SubRouter loggedIn roles={['role--accounting--stock']}>
    <Route path='*' element={<Index />} />
  </SubRouter>
))
